module.exports = __webpack_public_path__ + "img/TRASH.2b8ea9ac.svg";